/* eslint-disable */
export const shortcuts = [];
